export enum PermissionType {
  // General
  CAN_DEBUG_CMS = 'CAN_DEBUG_CMS',
  CAN_VIEW_SYSTEM_LINKS = 'CAN_VIEW_SYSTEM_LINKS',
  CAN_VIEW_SUPPORT_SECTION = 'CAN_VIEW_SUPPORT_SECTION',
  CAN_USE_COMMAND_PALETTE = 'CAN_USE_COMMAND_PALETTE',
  CAN_VIEW_MY_PROFILE = 'CAN_VIEW_MY_PROFILE',
  CAN_APPROVE_CONSENTS = 'CAN_APPROVE_CONSENTS',

  // Study Overview
  MANAGE_STUDY_CLOSE_OUT_TRACKER = 'MANAGE_STUDY_CLOSE_OUT_TRACKER',
  VIEW_OTHER_SITES_METRICS = 'VIEW_OTHER_SITES_METRICS',
  VIEW_STUDY_METRICS = 'VIEW_STUDY_METRICS',

  // Study Documents
  CAN_VIEW_STUDY_DOCUMENTS = 'CAN_VIEW_STUDY_DOCUMENTS',
  CAN_EDIT_STUDY_DOCS_FILE_ACCESS_LEVEL_ROLES = 'CAN_EDIT_STUDY_DOCS_FILE_ACCESS_LEVEL_ROLES',
  CAN_EMPTY_STUDY_DOCS_TRASH = 'CAN_EMPTY_STUDY_DOCS_TRASH',
  CAN_MANAGE_STUDY_DOCS_FOLDERS = 'CAN_MANAGE_STUDY_DOCS_FOLDERS',
  CAN_SET_STUDY_DOCS_FILE_ACCESS_LEVEL_ROLES = 'CAN_SET_STUDY_DOCS_FILE_ACCESS_LEVEL_ROLES',
  CAN_SET_STUDY_DOCS_FILE_COUNTRY_ACCESS_LEVEL = 'CAN_SET_STUDY_DOCS_FILE_COUNTRY_ACCESS_LEVEL',
  CAN_SET_STUDY_DOCS_FILE_LOCATION = 'CAN_SET_STUDY_DOCS_FILE_LOCATION',
  CAN_SET_STUDY_DOCS_FILE_STUDY_ACCESS_LEVEL = 'CAN_SET_STUDY_DOCS_FILE_STUDY_ACCESS_LEVEL',
  CAN_VIEW_STUDY_DOCS_COUNTRIES_FILTER = 'CAN_VIEW_STUDY_DOCS_COUNTRIES_FILTER',
  CAN_VIEW_STUDY_DOCS_ROLES_DETAILS = 'CAN_VIEW_STUDY_DOCS_ROLES_DETAILS',
  CAN_VIEW_STUDY_DOCS_ROLES_FILTER = 'CAN_VIEW_STUDY_DOCS_ROLES_FILTER',
  CAN_WRITE_TO_STUDY_DOCS_FILE = 'CAN_WRITE_TO_STUDY_DOCS_FILE',

  // Study Archiving
  CAN_VIEW_STUDY_ARCHIVING = 'CAN_VIEW_STUDY_ARCHIVING',
  CAN_EXPORT_MASTER_TEMPLATES = 'CAN_EXPORT_MASTER_TEMPLATES',
  CAN_REQUEST_ARCHIVING_EXPORT = 'CAN_REQUEST_ARCHIVING_EXPORT',
  CAN_DOWNLOAD_SITE = 'CAN_DOWNLOAD_SITE',

  // Patients
  CAN_VIEW_PATIENTS = 'CAN_VIEW_PATIENTS',
  CAN_EXPORT_CLOSEOUT_DATA = 'CAN_EXPORT_CLOSEOUT_DATA',
  MANAGE_HBS = 'MANAGE_HBS',
  MANAGE_MEDICATION = 'MANAGE_MEDICATION',
  MANAGE_PATIENT = 'MANAGE_PATIENT',
  MANAGE_RPM_EVENT = 'MANAGE_RPM_EVENT',
  MANAGE_VISIT = 'MANAGE_VISIT',
  READ_PATIENT = 'READ_PATIENT',
  VIEW_PATIENT_ACCOUNT = 'VIEW_PATIENT_ACCOUNT',
  VIEW_PATIENT_CONTACT_POINT = 'VIEW_PATIENT_CONTACT_POINT',
  VIEW_RTSM_CHIP = 'VIEW_RTSM_CHIP',

  // Questionnaires
  CAN_COMPILE_QUESTIONNAIRE = 'CAN_COMPILE_QUESTIONNAIRE',
  MANAGE_HEALTH_EVENT = 'MANAGE_HEALTH_EVENT',
  MANAGE_QUESTIONNAIRE_RESPONSE = 'MANAGE_QUESTIONNAIRE_RESPONSE',
  VIEW_HEALTH_EVENT_RESPONSE = 'VIEW_HEALTH_EVENT_RESPONSE',
  VIEW_QUESTIONNAIRE_RESPONSE = 'VIEW_QUESTIONNAIRE_RESPONSE',

  // Devices
  CAN_MANAGE_SPIROMETRY_SESSION = 'CAN_MANAGE_SPIROMETRY_SESSION',
  CAN_START_SPIROMETRY_SESSION = 'CAN_START_SPIROMETRY_SESSION',
  CAN_INITIATE_ON_DEMAND_MEASUREMENT_REQUEST = 'CAN_INITIATE_ON_DEMAND_MEASUREMENT_REQUEST',
  MANAGE_REQUEST_TAGS = 'MANAGE_REQUEST_TAGS',

  // Teams
  CAN_EXPORT_USER_REPORT = 'CAN_EXPORT_USER_REPORT',
  CAN_VIEW_REVOKED_POSITIONS = 'CAN_VIEW_REVOKED_POSITIONS',
  CAN_INVITE_TEAM_MEMBER = 'CAN_INVITE_TEAM_MEMBER',
  CAN_RESEND_TEAM_MEMBER_INVITE = 'CAN_RESEND_TEAM_MEMBER_INVITE',

  // Sites
  CAN_APPROVE_EC_STATUS = 'CAN_APPROVE_EC_STATUS',
  MANAGE_SITE_LOCATIONS = 'MANAGE_SITE_LOCATIONS',
  MANAGE_SITES = 'MANAGE_SITES',
  SITE_TEAM_ADMIN = 'SITE_TEAM_ADMIN',
  CAN_VIEW_SITES = 'CAN_VIEW_SITES',

  // Data Changes
  CAN_REVIEW_DATA_CHANGE = 'CAN_REVIEW_DATA_CHANGE',
  MANAGE_DATA_CHANGE_EDIT = 'MANAGE_DATA_CHANGE_EDIT',
  VIEW_DATA_CHANGE_EDIT = 'VIEW_DATA_CHANGE_EDIT',
  CAN_BYPASS_DATA_CHANGE_REVIEW = 'CAN_BYPASS_DATA_CHANGE_REVIEW',

  // Reports
  VIEW_USER_DETAILS_REPORT = 'VIEW_USER_DETAILS_REPORT',
  REQUEST_ATR_ON_DEMAND = 'REQUEST_ATR_ON_DEMAND',
  CAN_VIEW_REPORTS = 'CAN_VIEW_REPORTS',

  // Provisioned devices
  CAN_MANAGE_PROVISIONED_DEVICE = 'CAN_MANAGE_PROVISIONED_DEVICE',

  // Informed consent
  CAN_LIST_STUDY_ICFS = 'CAN_LIST_STUDY_ICFS',
  CAN_MANAGE_STUDY_ICFS = 'CAN_MANAGE_STUDY_ICFS',
  CAN_VIEW_STUDY_ICF = 'CAN_VIEW_STUDY_ICF',
  CAN_LIST_COUNTRY_ICFS = 'CAN_LIST_COUNTRY_ICFS',
  CAN_MANAGE_COUNTRY_ICF = 'CAN_MANAGE_COUNTRY_ICFS',
  CAN_VIEW_COUNTRY_ICF = 'CAN_VIEW_COUNTRY_ICF',
  CAN_LIST_PRACTICE_ICFS = 'CAN_LIST_PRACTICE_ICFS',
  CAN_MANAGE_PRACTICE_ICFS = 'CAN_MANAGE_PRACTICE_ICFS',
  CAN_VIEW_PRACTICE_ICF = 'CAN_VIEW_PRACTICE_ICF',
}
